import { _js } from '@ifixit/utils/localize';
import { faListUl } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const BulletListButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('bulletList'),
      isDisabled: !editor.can().toggleBulletList(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBulletList().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faListUl} />}
         title={_js('Add a bulleted list')}
         shortcut={'shift+8'}
      />
   );
};
